import { types } from './actions';

import initialState from '../../stores/initialState';
import { clearParams } from '../common/helpers';

// eslint-disable-next-line default-param-last
function loginViewReducer(state = initialState.login, action) {
  switch (action.type) {
    case types.LOGIN_FULFILLED:
      return { ...state,
        loginStatus: true,
        loginResult: action.result.access_token };
    case types.LOGIN_REJECTED:
      return { ...state,
        loginStatus: false,
        loginResult: false,
        msg: action.result.error?.response?.data?.msg,
        redirect: true };
    case types.CLOCK_IN_FULFILLED:
    case types.CLOCK_IN_REJECTED:
      return { ...state, redirect: true };
    case types.CLEAR_LOGIN_STATUS:
      return { ...state, ...initialState.login };
    case types.USER_PRIVILEGES_FULFILLED:
      return { ...state, prevSessionExists: true, redirect: true };
    case types.USER_PRIVILEGES_REJECTED:
      clearParams();
      return { ...state, prevSessionExists: false, tokenExpired: true };
    case types.GET_EXTERNAL_SIGNIN_PARAMS_FULFILLED:
        return { ...state, ssoEnable: action.result.ssoEnable, kerberosEnable: action.result.kerberosEnable };
    default:
      return state;
  }
}

export default loginViewReducer;